import BaseApi from './base'

const path = '/admin/menu'
export default class MenuApi extends BaseApi {
  constructor() {
    super(path)
  }
  static GetInstance = () => new MenuApi()
  
  getMenu = (id) => this.get(`${path}`, id ? { parentId: id } : null)
  getTopMenu = () => this.get(`${path}`, { type: 'top' })
  fetchMenuTree = (params) => this.get(`${path}/tree`, params)
}
